var componentRequireContext = require.context('components/MessageBoard', true)
var ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
